import React, { useEffect, useState } from 'react';

function AdminPayments() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchPayments = async () => {
    setLoading(true); setError('');
    try {
      const token = localStorage.getItem('token');
      const headers = token ? { 'x-auth-token': token } : {};
      const resp = await fetch('/api/admin/payments', { headers });
      if (!resp.ok) {
        const err = await resp.json().catch(() => ({}));
        throw new Error(err.error || 'Failed to fetch payments (endpoint may not be implemented)');
      }
      const data = await resp.json();
      // server returns an array of payment items
      setItems(Array.isArray(data) ? data : (data.items || []));
    } catch (err) {
      setError(err.message);
    } finally { setLoading(false); }
  };

  useEffect(() => { fetchPayments(); }, []);

  return (
    <div className="page admin-payments-page">
      <header className="page-header">
        <span className="page-eyebrow">Admin</span>
        <h1>Payments</h1>
        <p className="page-subtitle">Recent payment events (requires server-side endpoint GET /api/admin/payments).</p>
      </header>

      {error && <div className="alert alert-danger">{error}</div>}

      <div className="admin-actions">
        <button className="btn btn-outline-secondary" onClick={fetchPayments} disabled={loading}>{loading ? 'Loading...' : 'Refresh'}</button>
      </div>

      <section className="panel mt-3">
        {loading ? <p>Loading payments…</p> : (
          items.length === 0 ? <div className="admin-empty">No payment items or endpoint not implemented.</div> : (
            <table className="table">
              <thead><tr><th>ID</th><th>User</th><th>Amount</th><th>Status</th><th>Created</th></tr></thead>
              <tbody>
                {items.map(p => (
                  <tr key={p.id || p._id}>
                    <td>{p.id || p._id}</td>
                    <td>{p.user ? (<a href={`/admin/users?selected=${p.user.id}`}>{p.user.email}</a>) : (p.metadata && p.metadata.userId) || p.customer || '—'}</td>
                    <td>{typeof p.amount === 'number' ? (p.amount/100).toFixed(2) : ''}</td>
                    <td>{p.status || p.state || ''}</td>
                    <td>{(p.created || p.createdAt) ? new Date((p.created || p.createdAt) * 1000).toLocaleString() : ''}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )
        )}
      </section>
    </div>
  );
}

export default AdminPayments;
